import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface UserLinkProps{
	compact?: boolean,
	blank?: boolean,
	includeId?: boolean,
	user: {
		user_id: number,
		fist_name: string,
		last_name?: string,
	}
}

var UserLink = (props: UserLinkProps)=>{
	
	return <Link to={`/users/${props.user.user_id}`} target={props.blank ? '_blank' : null} className={classNames({
		compact: props.compact,
	})}>
		{props.includeId ? `[${props.user.user_id}]` : null}
		{props.user.fist_name} {props.user.last_name}
	</Link>
}

export default UserLink;